import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import markUrl from '@yakoot/brand/assets/logo/yakoot-mark-color.svg?url';
import './index.css';
import { JoinPage } from './JoinPage';

const icon = document.createElement('link');
icon.rel = 'icon';
icon.type = 'image/svg+xml';
icon.href = markUrl;
document.head.appendChild(icon);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');
createRoot(rootEl).render(
  <StrictMode>
    <JoinPage />
  </StrictMode>,
);
